import { DeleteOutlined, EyeOutlined, PlusOutlined } from "@ant-design/icons";
import { message, Modal, Upload } from "antd";
import type { RcFile, UploadProps } from "antd/es/upload";
import type { UploadFile } from "antd/es/upload/interface";
import { FC, useEffect, useState } from "react";
import { UploadImagesProps } from "./interface";
import { useAppSelector } from "store";
import { backendUrl } from "config";

const getBase64 = (file: RcFile): Promise<string> =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result as string);
    reader.onerror = (error) => reject(error);
  });

const UploadImagesUser: FC<UploadImagesProps> = ({
  maximumUploadItems,
  disabled,
  isEdit,
  value,
  allowFileExtensions,
  onChange,
  typeUpload,
}) => {
  const accessTokenKey = useAppSelector((state) => state.auth.accessToken);
  const uploadType = typeUpload ? typeUpload : "product";

  // console.log("value--->", value);

  const [previewOpen, setPreviewOpen] = useState(false);
  const [previewImage, setPreviewImage] = useState("");
  const [previewTitle, setPreviewTitle] = useState("");
  const [fileList, setFileList] = useState<UploadFile[] | undefined>(value);

  // const [init, setInit] = useState(false);
  useEffect(() => {
    setFileList(value);
  }, [value]);

  const handleCancel = () => setPreviewOpen(false);
  const handlePreview = async (file: UploadFile) => {
    if (!file.url && !file.preview) {
      file.preview = await getBase64(file.originFileObj as RcFile);
    }

    setPreviewImage(file.url || (file.preview as string));
    setPreviewOpen(true);
    setPreviewTitle(
      file.name || file.url!.substring(file.url!.lastIndexOf("/") + 1)
    );
  };

  const handleChange: UploadProps["onChange"] = ({ fileList: newFileList }) => {
    const newFileListUrl = newFileList.map((item) => {
      if (item.response) {
        return {
          ...item,
          url: item.response.url,
          id: item.response.id,
        };
      }
      return item;
    });
    setFileList(newFileListUrl);
    onChange?.(newFileListUrl);
  };

  const onBeforeUpload: UploadProps["beforeUpload"] = (file) => {
    //change file name
    const fileName = file.name.split(".");
    const fileExtension = fileName[fileName.length - 1];
    const newFileName = `${Date.now()}.${fileExtension}`;
    const newFile = new File([file], newFileName, { type: file.type });

    //check file size
    if (file.size > 1024 * 1024 * 5) {
      message.error("ไฟล์ขนาดใหญ่เกิน 5 MB");
      return Upload.LIST_IGNORE;
    }

    return newFile;
  };

  const uploadButton = (
    <div>
      <PlusOutlined style={{ color: "#417B97" }} />
      <div style={{ marginTop: 8, color: "#417B97" }}>เพิ่มรูปภาพ</div>
    </div>
  );


  const itemRender = (
    originNode: React.ReactNode,
    file: UploadFile,
    fileList: UploadFile[],
    actions: { remove: () => void }
  ) => {
    return (
      <div className="custom-upload-item">
        <div className="image-container">{originNode}</div>
      </div>
    );
  };

  return (
    <>
      <Upload
        disabled={disabled}
        action={`${backendUrl}images/upload?type=${uploadType}`}
        listType="picture-card"
        fileList={fileList}
        onPreview={handlePreview}
        onChange={handleChange}
        maxCount={maximumUploadItems}
        accept={allowFileExtensions}
        itemRender={itemRender}
        onRemove={(file) => {
          const newFileList = fileList?.filter((item) => item.uid !== file.uid);
          setFileList(newFileList);
          onChange?.(newFileList);
        }}
        headers={{
          Authorization: `Bearer ${accessTokenKey}`,
        }}
        beforeUpload={onBeforeUpload}
      >
        {fileList && fileList.length >= maximumUploadItems
          ? null
          : uploadButton}
      </Upload>
      <Modal
        open={previewOpen}
        title={previewTitle}
        footer={null}
        onCancel={handleCancel}
      >
        <img alt="example" style={{ width: "100%" }} src={previewImage} />
      </Modal>
    </>
  );
};

export default UploadImagesUser;
